import ListingType from './listing-type';
var BreadcrumbLabels = {
  [ListingType.SALES_RESIDENTIAL.name]: {
    browse: 'Buy',
    search: 'Residential Sales Search'
  },
  [ListingType.RENTAL_RESIDENTIAL.name]: {
    browse: 'Rent',
    search: 'Residential Rentals Search'
  },
  [ListingType.RENTAL_COMMERCIAL.name]: {
    browse: 'Rent',
    search: 'Commercial Rentals Search'
  },
  [ListingType.SALES_COMMERCIAL.name]: {
    browse: 'Buy',
    search: 'Commercial Sales Search'
  },
  [ListingType.SALES_BUSINESS.name]: {
    browse: 'Buy',
    search: 'Business Sales Search'
  },
  [ListingType.SHARE_RESIDENTIAL.name]: {
    browse: 'Share',
    search: 'Residential Shares Search'
  },
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: {
    browse: 'New Homes',
    search: 'New Homes Search'
  },
  [ListingType.SALES_EARLY_ACCESS.name]: {
    browse: 'Buy',
    search: 'Residential Sales Search'
  }
};
export default BreadcrumbLabels;